import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr";
import FlatpickrShortcuts from "shortcut-buttons-flatpickr";
import $ from 'jquery';
import { Modal } from "bootstrap"
import { getDateFromRelativeDate, getModal } from "../helpers";

export default class extends Controller {
  static targets = [
    "offcanvasTimeline",
    "offcanvasTimelineSidebar",
    "dropdownStatus",
    "datepicker",
    "sendAsvBtn",
    "timepicker",
    "submitBtnDateTime",
    "referredProviderDropdownMenu",
    "appointmentType",
    "closeReferral",
    "inputLocation",
    "hiddenInputLocationId",
    "locationDropdown",
    "locationDropdownItems",
    "inputProvider",
    "hiddenInputProviderId",
    "providerDropdown",
    "providerDropdownItems",
    "datetimepicker",
    "datePickerWrapper",
    "scheduleState",
    "assignmentFields",
    "confirmAssignBtn",
    "notice",
    "unscheduleCheckbox",
    "hiddenInputAcceptReferral",
    "onHoldReminder",
    "customSnoozeReminder",
    "modalCompletedDialog"
  ]

  connect() {
    $("tr[data-link]").click(function () {
      $.ajax({
        dataType: "script",
        url: $(this).data("link"),
      });
    });

    if (this.hasTimepickerTarget) {
      this.populateTimepicker();
      $(this.timepickerTarget).val(this.timepickerTarget.dataset.value)
    }

    if (this.hasDatepickerTarget) {
      this.initDatepicker();
    }
    if (this.hasAppointmentStatusTarget) {
      const selectedValue = this.appointmentTypeTarget.dataset.value;

      const radioButtons = this.appointmentTypeTarget.querySelectorAll('input[type="radio"]');
      radioButtons.forEach(radio => {
        if (radio.value === selectedValue) {
          radio.checked = true;
        }

        radio.addEventListener('change', () => {
          this.checkDateTimeSelected();
        });
      });
    }

    if (this.hasDatetimepickerTarget) {
      this.initDatetimepicker();
    }

    document.addEventListener("click", this.closeDropdowns.bind(this));

    const sendCopyModal = document.getElementById('modal_send_copy_to_patient')
    if (sendCopyModal) {
      this._sendCopyModalShown = () => this.validateSendCopy()
      sendCopyModal.addEventListener('shown.bs.modal', this._sendCopyModalShown)
    }

    this.checkForModalOpen();
    
    if (this.hasHiddenInputLocationIdTarget && this.hasProviderDropdownItemsTarget) {
      const initialLocationId = this.hiddenInputLocationIdTarget.value;
      if (initialLocationId) {
        this.filterReferredProvidersByLocation(initialLocationId);
      }
    }
    
   
  }

  onHoldReminderTargetConnected(ee) {
    $(this.onHoldReminderTarget).on('click', '.dropdown-menu li', (e) => {
      const relativeReminder = e.target.dataset.onholdReminder
      this.toggleOnHoldReminder(relativeReminder)
    })
  }

  modalCompletedDialogTargetConnected(ee) {
    const closeModal = getModal("modal_close_referral")
    const isOpen = !!closeModal && closeModal._element.classList.contains("show");
    if(isOpen) {
      // only open modal if close modal is open, indicate closing request
      closeModal.hide();
      getModal("modal_completed_referral").show();
    }
  }

  toggleOnHoldReminder(relativeReminder) {
    if(relativeReminder == 'Custom'){
      this.customSnoozeReminderTarget.classList.remove('d-none')
    }else{
      this.customSnoozeReminderTarget.classList.add('d-none')
      const date = getDateFromRelativeDate(relativeReminder)
      this.customSnoozeReminderTarget.querySelector('#snooze_reminder_date')._flatpickr.setDate(date)
    }
    this.onHoldReminderTarget.querySelector('.selected-date').innerText = relativeReminder
  }

  toggleTimelineText(event) {
    let container = event.currentTarget.closest(".nested-comment-content");
    if (container) {
      let noteTimeline = container.querySelector(".note-timeline");
      noteTimeline.classList.toggle("truncate");
      event.currentTarget.textContent =
        event.currentTarget.textContent.includes("Show More")
          ? "Show Less"
          : "Show More";
    }
  }

  initDatepicker() {
    const datepickerElement = $(this.datepickerTarget);
    const defaultDate = this.datepickerTarget.dataset.value

    flatpickr(datepickerElement, {
      defaultDate: defaultDate,
      allowInput: true,
      altInput: true,
      altFormat: "M j, Y",
      plugins: [
        FlatpickrShortcuts({
          button: [
            {
              label: "Clear",
            },
          ],
          onClick: (index) => {
            switch (index) {
              case 0:
                datepickerElement[0]._flatpickr.clear();
                datepickerElement[0]._flatpickr.close();
                break;
            }
          },
        }),
      ],
      onChange: this.checkDateTimeSelected.bind(this),
    });
  }

  populateTimepicker() {
    const timepickerElement = this.timepickerTarget;
    const increment = 15;
    timepickerElement.innerHTML = '';
    timepickerElement.innerHTML += `<option value="" selected>Select a time</option>`;

    for (let hour = 6; hour <= 18; hour++) {
      for (let minute = 0; minute < 60; minute += increment) {
        if (hour === 18 && minute > 0) {
            break;
        }
        const timeString = this.formatTime12Hour(hour, minute);
        timepickerElement.innerHTML += `<option value="${timeString}">${timeString}</option>`;
      }
    }
    timepickerElement.addEventListener('change', this.checkDateTimeSelected.bind(this));
  }

  saveDateTime() {
    if (this.submitBtnDateTimeTarget.disabled) return;
    this.submitBtnDateTimeTarget.disabled = true;
    const scheduleState = this.currentScheduleState();
    const selectedRadio = this.appointmentTypeTarget.querySelector('input[name="appointment_type"]:checked');
    const appointmentType = selectedRadio ? selectedRadio.value : null;
    const referralId = this.datetimepickerTarget.dataset.referralDetailId;

    const appointmentDate = scheduleState === "scheduled" ? this.datetimepickerTarget.value : null;

    if (!appointmentType) return;
    if (scheduleState === "scheduled" && !appointmentDate) return;

    this.updateAppointmentDateTime(appointmentDate, referralId, appointmentType, scheduleState);
  }

  updateAppointmentDateTime(dateTimeString, referralId, appointmentStatus, scheduleState) {
    const payload = {
      appointment_date: dateTimeString,
      status: appointmentStatus,
      schedule_state: scheduleState
    };

    if (this.hasHiddenInputProviderIdTarget && this.hiddenInputProviderIdTarget.value) {
      payload.referred_provider_id = this.hiddenInputProviderIdTarget.value;
    }
    if (this.hasHiddenInputLocationIdTarget && this.hiddenInputLocationIdTarget.value) {
      payload.referred_location_id = this.hiddenInputLocationIdTarget.value;
    }

    $.ajax({
      method: "PUT",
      url: `/referrals/${referralId}/update_appointment_date`,
      data: payload,
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
      },
      success: (data) => {
        window.location.reload();
      },
    });

    this.checkDateTimeSelected();
  }

  currentScheduleState() {
    if (this.hasScheduleStateTarget) {
      const selected = this.scheduleStateTarget.querySelector('input[name="schedule_state"]:checked');
      if (selected) return selected.value;
    }
    // Legacy fallback for any caller still using the unscheduled checkbox.
    if (this.hasUnscheduleCheckboxTarget && this.unscheduleCheckboxTarget.checked) {
      return "unscheduled";
    }
    return "scheduled";
  }

  toggleScheduleState() {
    const state = this.currentScheduleState();
    if (this.hasDatePickerWrapperTarget) {
      if (state === "scheduled") {
        this.datePickerWrapperTarget.classList.remove("d-none");
      } else {
        this.datePickerWrapperTarget.classList.add("d-none");
        if (this.hasDatetimepickerTarget && this.datetimepickerTarget._flatpickr) {
          this.datetimepickerTarget._flatpickr.clear();
        } else if (this.hasDatetimepickerTarget) {
          this.datetimepickerTarget.value = "";
        }
      }
    }
    if (this.hasAssignmentFieldsTarget) {
      if (state === "unscheduled") {
        this.assignmentFieldsTarget.classList.add("d-none");
      } else {
        this.assignmentFieldsTarget.classList.remove("d-none");
      }
    }
    this.checkDateTimeSelected();
  }

  formatTime12Hour(hour, minute) {
    const period = hour < 12 ? "AM" : "PM";
    let adjustedHour = hour % 12;
    if (adjustedHour === 0) {
      adjustedHour = 12;
    }
    const hourString = adjustedHour.toString().padStart(2, '0');
    const minuteString = minute.toString().padStart(2, '0');
    return `${hourString}:${minuteString} ${period}`;
  }

  checkDateTimeSelected() {
    const selectedRadio = this.appointmentTypeTarget.querySelector('input[name="appointment_type"]:checked');
    const appointmentType = selectedRadio ? selectedRadio.value : null;
    const submitButton = this.submitBtnDateTimeTarget;
    const scheduleState = this.currentScheduleState();
    const appointmentDateTime = this.hasDatetimepickerTarget ? this.datetimepickerTarget.value : "";

    const dateRequirementMet = scheduleState !== "scheduled" || !!appointmentDateTime;
    submitButton.disabled = !(appointmentType && dateRequirementMet);
  }

  dropdownStatusTargetConnected() {
    const referralStatus = this.dropdownStatusTarget.innerText.trim();

    if (referralStatus === "Completed") {
      this.sendAsvBtnTarget.classList.remove("d-none");
    } else {
      this.sendAsvBtnTarget.classList.add("d-none");
    }
  }

  closeReferral(e){
    this.closeReferralTarget.classList.add("btn-lock");
  }

  activateCloseReferral(e) {
    $('[data-referral-detail-target="closeReferral"]').removeClass("btn-lock")
  }

  toggleOffcanvasTimeline(event) {
    this.offcanvasTimelineTarget.style.display = 'block';
    this.offcanvasTimelineTarget.classList.add('offcanvas-open');
    this.offcanvasTimelineSidebarTarget.classList.add('d-none');
  }

  closeOffcanvasTimeline() {
    this.offcanvasTimelineTarget.classList.remove('offcanvas-open');
    this.offcanvasTimelineTarget.style.display = 'none';
    this.offcanvasTimelineSidebarTarget.classList.remove('d-none');
  }

  changeReferredProviderDropdownMenuText(e) {
    this.referredProviderDropdownMenuTarget.innerHTML = e.target.innerText;
  }

  disconnect() {
    document.removeEventListener("click", this.closeDropdowns.bind(this));
    const sendCopyModal = document.getElementById('modal_send_copy_to_patient')
    if (sendCopyModal && this._sendCopyModalShown) {
      sendCopyModal.removeEventListener('shown.bs.modal', this._sendCopyModalShown)
    }
  }

  showDropdown(type) {
    type = typeof type == "string" ? type : type.target.dataset.type
    if (type === "location" && this.hasLocationDropdownTarget) {
      this.locationDropdownTarget.classList.remove("d-none");
      this.hideDropdown("provider");
    } else if (type === "provider" && this.hasProviderDropdownTarget) {
      this.providerDropdownTarget.classList.remove("d-none");
      this.hideDropdown("location");
    }
  }

  hideDropdown(type) {
    if (type === "location" && this.hasLocationDropdownTarget) {
      this.locationDropdownTarget.classList.add("d-none");
    } else if (type === "provider" && this.hasProviderDropdownTarget) {
      this.providerDropdownTarget.classList.add("d-none");
    }
  }

  filterList(event) {
    const type = event.currentTarget.dataset.type;
    const searchText = event.currentTarget.value ? event.currentTarget.value.toLowerCase() : "";
    const filterType = event.currentTarget.dataset.filterType;

    let items;
    if (type === "location" && filterType != "provider" && this.hasLocationDropdownItemsTarget) {
      items = this.locationDropdownItemsTarget.querySelectorAll("li");
    } else if (type === "provider" && this.hasProviderDropdownItemsTarget) {
      items = this.providerDropdownItemsTarget.querySelectorAll("li");
    } else if (filterType === 'provider'){
      this.filterReferredProvidersByLocation(event.currentTarget.dataset.id)
      return;
    } else {
      return;
    }

    items.forEach((item) => {
      const text = item.dataset.name ? item.dataset.name.toLowerCase() : "";
      item.style.display = text.includes(searchText) ? "block" : "none";
    });

    this.showDropdown(type);
  }

  selectItem(event) {
    if (event.target.tagName.toLowerCase() === "input" && event.target.type === "checkbox") {
      return;
    }

    const { id, name, type } = event.currentTarget.dataset;

    if (type === "location") {
      if (this.hasInputLocationTarget && this.hasHiddenInputLocationIdTarget) {
        this.inputLocationTarget.value = name;
        this.hiddenInputLocationIdTarget.value = id;
      }
    } else if (type === "provider") {
      if (this.hasInputProviderTarget && this.hasHiddenInputProviderIdTarget) {
        this.inputProviderTarget.value = name;
        this.hiddenInputProviderIdTarget.value = id;
      }
      if (this.hasConfirmAssignBtnTarget && (id || event.currentTarget.dataset.unassign === "true")) {
        this.confirmAssignBtnTarget.disabled = false;
      }
    }

    this.hideDropdown(type);
    if (type === "location") this.filterList(event)
  }

  closeDropdowns(event) {
    if (
      (this.hasInputLocationTarget && this.inputLocationTarget.contains(event.target)) ||
      (this.hasLocationDropdownTarget && this.locationDropdownTarget.contains(event.target)) ||
      (this.hasInputProviderTarget && this.inputProviderTarget.contains(event.target)) ||
      (this.hasProviderDropdownTarget && this.providerDropdownTarget.contains(event.target))
    ) {
      return;
    }

    if (this.hasLocationDropdownTarget) this.hideDropdown("location");
    if (this.hasProviderDropdownTarget) this.hideDropdown("provider");
  }

  checkForModalOpen() {
    if (this.element.dataset.showSendCopy === 'true') {
      const modal = document.getElementById('modal_send_copy_to_patient')
      if (modal) {
        new Modal(modal).show()
        this.validateSendCopy()

        const url = new URL(window.location)
        url.searchParams.delete('show_send_copy')
        window.history.replaceState({}, '', url)
      }
    }
  }

  handleModalSmsToggle(e) {
    const isOn = e.target.checked
    const statusLabel = document.getElementById('modal-sms-status')
    const wrapper = document.getElementById('modal-contact-wrapper')
    const subtitle = document.getElementById('modal-subtitle')
    const consentNote = document.getElementById('modal-consent-note')
    const sendBtn = document.getElementById('modal-send-copy-btn')

    if (statusLabel) {
      statusLabel.textContent = isOn ? 'On' : 'Off'
      statusLabel.style.color = isOn ? '#4168FF' : '#727272'
    }

    // Toggle subtitle and consent note visibility
    if (subtitle) subtitle.style.display = isOn ? 'none' : 'block'
    if (consentNote) consentNote.style.display = isOn ? 'block' : 'none'

    // Toggle send button style
    if (sendBtn) {
      if (isOn) {
        sendBtn.style.backgroundColor = '#4168FF'
        sendBtn.style.color = 'white'
      } else {
        sendBtn.style.backgroundColor = 'rgba(176,176,176,0.5)'
        sendBtn.style.color = 'rgba(0,0,0,0.5)'
      }
    }

    // Toggle contact wrapper style
    if (wrapper) {
      if (isOn) {
        wrapper.style.backgroundColor = ''
        wrapper.style.borderRadius = ''
        wrapper.style.padding = ''
      } else {
        wrapper.style.backgroundColor = 'rgba(188,188,188,0.1)'
        wrapper.style.borderRadius = '12px'
        wrapper.style.padding = '16px'
      }

      wrapper.querySelectorAll('.modal-contact-checkbox').forEach(cb => {
        cb.disabled = !isOn
        cb.style.opacity = isOn ? '1' : '0.3'
      })
      wrapper.querySelectorAll('.modal-contact-label').forEach(label => {
        label.style.opacity = isOn ? '1' : '0.3'
      })
      wrapper.querySelectorAll('.modal-contact-input').forEach(input => {
        input.disabled = !isOn
        if (isOn) {
          input.style.backgroundColor = 'white'
          input.style.border = '1px solid rgba(0,0,0,0.5)'
          input.style.opacity = '1'
        } else {
          input.style.backgroundColor = 'rgba(209,217,224,0.5)'
          input.style.border = '1px solid rgba(0,0,0,0.1)'
          input.style.opacity = '0.3'
        }
      })
    }

    this.validateSendCopy()
  }

  handleModalSmsTerms(e) {
    const agreed = e.target.checked
    const toggle = document.getElementById('modal-sms-toggle')
    const wrapper = document.getElementById('modal-sms-toggle-wrapper')

    if (toggle) {
      toggle.disabled = !agreed
      toggle.checked = agreed
      this.handleModalSmsToggle({ target: { checked: agreed } })
    }

    if (wrapper) {
      const existing = bootstrap.Tooltip.getInstance(wrapper)
      if (existing) existing.dispose()
      if (agreed) {
        wrapper.removeAttribute('title')
        wrapper.removeAttribute('data-bs-toggle')
      } else {
        wrapper.setAttribute('title', 'Agree to the terms below to enable')
        wrapper.setAttribute('data-bs-toggle', 'tooltip')
        wrapper.setAttribute('data-bs-placement', 'top')
        new bootstrap.Tooltip(wrapper)
      }
    }
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  isValidPhone(phone) {
    const digits = phone.replace('+1 ', '').replace(/\D/g, '')
    return digits.length >= 10
  }

  validateSendCopy() {
    const phoneCheck = document.getElementById('modal-phone-check')
    const emailCheck = document.getElementById('modal-email-check')
    const phoneInput = document.getElementById('modal-patient-phone')
    const emailInput = document.getElementById('modal-patient-email')
    const sendBtn = document.getElementById('modal-send-copy-btn')
    if (!sendBtn) return

    const phoneValid = phoneCheck && phoneCheck.checked && !phoneCheck.disabled && phoneInput && this.isValidPhone(phoneInput.value)
    const emailValid = emailCheck && emailCheck.checked && !emailCheck.disabled && emailInput && this.isValidEmail(emailInput.value)

    const valid = phoneValid || emailValid
    sendBtn.disabled = !valid
    if (valid) {
      sendBtn.style.backgroundColor = '#4168FF'
      sendBtn.style.color = 'white'
    } else {
      sendBtn.style.backgroundColor = 'rgba(176,176,176,0.5)'
      sendBtn.style.color = 'rgba(0,0,0,0.5)'
    }
  }

  async sendCopyToPatient(e) {
    const btn = e.currentTarget
    const modal = document.getElementById('modal_send_copy_to_patient')
    const referralId = modal.dataset.referralId
    const phoneCheck = document.getElementById('modal-phone-check')
    const emailCheck = document.getElementById('modal-email-check')
    const phoneInput = document.getElementById('modal-patient-phone')
    const emailInput = document.getElementById('modal-patient-email')
    const smsToggle = document.getElementById('modal-sms-toggle')

    const sendSms = phoneCheck && phoneCheck.checked && phoneInput && this.isValidPhone(phoneInput.value)
    const sendEmail = emailCheck && emailCheck.checked && emailInput && this.isValidEmail(emailInput.value)
    const savePreferences = smsToggle && smsToggle.checked

    btn.disabled = true
    btn.textContent = 'Sending...'

    const form = document.createElement('form')
    form.method = 'POST'
    form.action = `/referrals/${referralId}/send_copy_to_patient`

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const fields = {
      authenticity_token: csrfToken,
      phone_number: phoneInput ? phoneInput.value : '',
      email: emailInput ? emailInput.value : '',
      send_sms: sendSms ? 'true' : 'false',
      send_email: sendEmail ? 'true' : 'false',
      save_preferences: savePreferences ? 'true' : 'false'
    }

    for (const [key, value] of Object.entries(fields)) {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = key
      input.value = value
      form.appendChild(input)
    }

    document.body.appendChild(form)
    form.requestSubmit()
  }

  openAssignLocationModal(e) {
    const assign_action = e ? e.currentTarget.dataset.assignAction : 'assign_provider_and_location'
    const modalTarget = e && e.currentTarget.dataset.bsTarget ? e.currentTarget.dataset.bsTarget.replace('#', '') : null
    const modal = document.getElementById(modalTarget || 'modal_assign_location_provider');
    if (modal) {
      const bootstrapModal = new Modal(modal, {
        backdrop: modalTarget == 'modal_upgrade_account' ? true : false
      });
      bootstrapModal.show();
      if (this.hasHiddenInputAcceptReferralTarget){
        this.hiddenInputAcceptReferralTarget.value = assign_action == 'accept-referral';
      }
    }
  }

  openStatusChangeModal(e) {
    const actionType = e ? e.currentTarget.dataset.actionType : 'consultation'
    const noAction = e.currentTarget.dataset.noAction
    if (noAction == 'true' || noAction == true) return
    const modal = actionType == 'on_hold' ? '#modal_on_hold' : '#modal_schedule_appointment'

    if (modal == '#modal_schedule_appointment') {
      const phasePhases = ['initial_consult', 'treatment', 'follow_up'];
      const targetPhase = phasePhases.includes(actionType) ? actionType : 'initial_consult';
      const radio = document.querySelector(`input[name="appointment_type"][value="${targetPhase}"]`);
      if (radio) radio.checked = true;
    }
    const bootstrapModal = new Modal(modal);
    bootstrapModal.show()
  }

  filterReferredProvidersByLocation(locationId) {
    const items = this.providerDropdownItemsTarget.querySelectorAll("li") || [];
    const previousProvider = this.hasInputProviderTarget ? this.inputProviderTarget.value : '';
    let hasSelected = false
    items.forEach((item) => {
      const locationIds = item.dataset.locationIds ? item.dataset.locationIds.split(",") : []
      const hasLocation = item.dataset.unassign === "true" || locationIds.includes(locationId)
      item.style.display = hasLocation ? "block" : "none";
      hasSelected = hasSelected || (hasLocation && previousProvider && previousProvider == item.dataset.name)
    });
    if (!hasSelected && previousProvider) {
      const defaultItem = items.length > 0 ? items[0] : {}
      if (this.hasInputProviderTarget)  this.inputProviderTarget.value = defaultItem.dataset.name || "";
      if (this.hasHiddenInputProviderIdTarget) this.hiddenInputProviderIdTarget.value = defaultItem.dataset.id || ""
    }
  }

  countCharacters(pointerEvent) {
    const count = pointerEvent.target.value.length;

    document.getElementById('CharacterCount').innerText = count + "/750";
  }

  initDatetimepicker() {
    const el = this.datetimepickerTarget;
    const rawValue = el.dataset.value;

    // Mobile uses native datetime-local input (set in the mobile modal partial)
    if (el.type === 'datetime-local') {
      if (rawValue) {
        el.value = rawValue.substring(0, 16);
      }
      el.addEventListener('change', this.checkDateTimeSelected.bind(this));
      return;
    }

    const defaultDate = rawValue ? new Date(rawValue) : null;

    flatpickr(el, {
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      altInput: true,
      altFormat: "M j, Y h:i K",
      defaultDate: defaultDate,
      allowInput: true,
      time_24hr: false,
      onChange: this.checkDateTimeSelected.bind(this)
    });
  }

  hideNotice() {
    if (this.hasNoticeTarget) {
      this.noticeTarget.remove();
    }
  }

  toggleUnscheduled(event) {
    const checked = event.target.checked;
    const el = this.datetimepickerTarget;
    const flatpickrInstance = el._flatpickr;
    const visibleInput = flatpickrInstance?.altInput || el;

    if (checked) {
      visibleInput.disabled = true;
      this.submitBtnDateTimeTarget.classList.remove('btn-lock');
      this.submitBtnDateTimeTarget.classList.add('btn-active');

      if (flatpickrInstance) {
        flatpickrInstance.clear();
      } else {
        el.value = '';
      }
    } else {
      visibleInput.disabled = false;
      this.checkDateTimeSelected();
    }
  }
}
